"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "routes", {
    enumerable: true,
    get: function() {
        return routes;
    }
});
const _types = require("./types");
const routes = (0, _types.buildRoutes)({
    workflowDefinition: {
        path: "/workflows/:workflowDefinitionId/overview"
    },
    listWorkflows: {
        path: "/workflows/:workflowDefinitionId"
    },
    workflow: {
        path: "/workflow/:workflowId"
    },
    workflowsTable: {
        path: "/workflows/:workflowDefinitionId/table"
    }
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3JvdXRpbmcvd29ya2Zsb3dzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGJ1aWxkUm91dGVzIH0gZnJvbSBcIi4vdHlwZXNcIjtcblxuZXhwb3J0IGNvbnN0IHJvdXRlcyA9IGJ1aWxkUm91dGVzKHtcbiAgd29ya2Zsb3dEZWZpbml0aW9uOiB7XG4gICAgcGF0aDogXCIvd29ya2Zsb3dzLzp3b3JrZmxvd0RlZmluaXRpb25JZC9vdmVydmlld1wiLFxuICB9LFxuICBsaXN0V29ya2Zsb3dzOiB7XG4gICAgcGF0aDogXCIvd29ya2Zsb3dzLzp3b3JrZmxvd0RlZmluaXRpb25JZFwiLFxuICB9LFxuICB3b3JrZmxvdzoge1xuICAgIHBhdGg6IFwiL3dvcmtmbG93Lzp3b3JrZmxvd0lkXCIsXG4gIH0sXG4gIHdvcmtmbG93c1RhYmxlOiB7XG4gICAgcGF0aDogXCIvd29ya2Zsb3dzLzp3b3JrZmxvd0RlZmluaXRpb25JZC90YWJsZVwiLFxuICB9LFxufSk7XG4iXSwibmFtZXMiOlsicm91dGVzIiwiYnVpbGRSb3V0ZXMiLCJ3b3JrZmxvd0RlZmluaXRpb24iLCJwYXRoIiwibGlzdFdvcmtmbG93cyIsIndvcmtmbG93Iiwid29ya2Zsb3dzVGFibGUiXSwibWFwcGluZ3MiOiI7Ozs7K0JBRWFBOzs7ZUFBQUE7Ozt1QkFGZTtBQUVyQixNQUFNQSxTQUFTQyxJQUFBQSxrQkFBVyxFQUFDO0lBQ2hDQyxvQkFBb0I7UUFDbEJDLE1BQU07SUFDUjtJQUNBQyxlQUFlO1FBQ2JELE1BQU07SUFDUjtJQUNBRSxVQUFVO1FBQ1JGLE1BQU07SUFDUjtJQUNBRyxnQkFBZ0I7UUFDZEgsTUFBTTtJQUNSO0FBQ0YifQ==